export enum NotificationButtonType {
  Positive,
  Negative,
  Neutral,
}
